module.exports = __webpack_public_path__ + "static/img/u15.ebe44172.png";